module.exports = __webpack_public_path__ + "img/fylke-19.fe869c63.svg";